import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { ReactComponent as EditSvg } from '../../assets/i_edit.svg';
import { ReactComponent as ResetSvg } from '../../assets/i_reset.svg';
// import { ReactComponent as DuplicateSvg } from '../../assets/i_duplicate.svg';
import { ReactComponent as DeleteSvg } from '../../assets/i_delete.svg';
import { UnitsToggler } from "./UnitsToggler";

const DropdownActionButtons = ({
  isEditing,
  handleActivityEdit,
  handleActivityReset,
  handleActivitySaveCopy,
  handleActivityDelete,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => { setDropdownOpen(prevState => !prevState); }

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} className="action-dropdown">
        <DropdownToggle caret className="dropdown-toggle btn btn-light control-button">
        More
        </DropdownToggle>
        <DropdownMenu>
        <DropdownItem header></DropdownItem>
        <DropdownItem>
        {isEditing ? (
        <div></div>
        ) : (
            <div
            title="Edit activity"
            onClick={handleActivityEdit}
            className="btn btn-light control-button activity-buttons-more">
            <i className="activity_icons"><EditSvg /></i>
            Edit Activity
            </div>
        )}
        </DropdownItem>
        <DropdownItem>
            <div
            title="Reset activity"
            className="btn btn-light control-button activity-buttons-more"
            onClick={handleActivityReset}
            >
            <i className="activity_icons"><ResetSvg /></i>
            Reset Activity
            </div>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem>              
            <div
            title="Delete activity"
            className="btn btn-light control-button activity-buttons-more"
            onClick={handleActivityDelete}
        >
            <i className="activity_icons"><DeleteSvg /></i>
            Delete Activity
        </div>
        </DropdownItem>
        <DropdownItem>              
            <UnitsToggler />
        </DropdownItem>
        </DropdownMenu>
    </Dropdown>
  );
};

export default DropdownActionButtons;
